/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDiagLabInventoryType } from 'app/shared/model/diag-lab-inventory-type.model';
import { IDiagLabInventory } from 'app/shared/model/diag-lab-inventory.model';

export interface IDiagLabInventoryCheckout {
  id?: string;
  brandId?: string | null;
  batchNumber?: string | null;
  serialNumber?: string;
  remainingUses?: number | null;
  avgUsesPerItem?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  diagLab?: IDiagLab | null;
  type?: IDiagLabInventoryType | null;
  inventory?: IDiagLabInventory | null;
}

export const defaultValue: Readonly<IDiagLabInventoryCheckout> = {
  active: false,
};
